import React from 'react';
import styled from 'styled-components';
import { Route, Switch, Link } from 'library/util/core-router';
import withData from 'util/hoc/with-data';
import ReferralEngineQuery from 'apps/admin/util/query';
import { object, bool, array, func } from 'prop-types';
import Loading from 'components/loading';
import DeterminerForm from 'apps/admin/pages/persona-determiners/determiners/components/determiner-form';
import PersonaTable from 'apps/admin/pages/persona-determiners/personas/persona-table';
import ReloadParentWrapper from 'structures/reload-parent-wrapper';
import DeterminerTable from 'apps/admin/pages/persona-determiners/determiners/components/determiner-table';
import PersonaForm from 'apps/admin/pages/persona-determiners/personas/persona-form';
import { resolve } from 'library/helpers/path-resolver';

const LinkHolder = styled.div`
  position: relative;
  height: 50px;
  display: flex;
`;

const StyledLink = styled(Link)`
  display: flex;
  width: 150px;
  height: 50px;
  margin: 0 1em;
  justify-content: center;
  align-items: center;
`;

const Determiners = (props) => {

  const {
    graph_loading,
    graph_data: {
      determiners,
      personas,
      outcomes
    },
    reload_graph
  } = props;

  if(graph_loading) return <Loading />;

  const resourceType = () => (
    resolve(props, 'location/pathname', '').includes('/personas') ? 'personas' : 'determiners'
  );

  return (
    <ReloadParentWrapper reload_graph={reload_graph}>
      <LinkHolder>
        <StyledLink to='/admin/persona-determiners'><span>Determiners</span></StyledLink>
        <StyledLink to='/admin/persona-determiners/personas'><span>Personas</span></StyledLink>
        <StyledLink to={`/admin/persona-determiners/${resourceType()}/new`}><span>New</span></StyledLink>
      </LinkHolder>
      <Switch>
        <Route path="/admin/persona-determiners"
          exact={true}
          component={() => <DeterminerTable determiners={determiners} />}
        />

        <Route path="/admin/persona-determiners/personas" exact={true} component={() => <PersonaTable personas={personas}/>} />
        <Route path="/admin/persona-determiners/personas/new" exact={true} component={() => <PersonaForm outcomes={outcomes} />} />
        <Route path="/admin/persona-determiners/personas/:id" render={({match: {params: {id}}}) => (
          <PersonaForm outcomes={outcomes} persona={personas.find((persona) => persona.id == id)}/>
        )} />

        <Route path="/admin/persona-determiners/:id" render={({match: {params: {id}}}) => (
          <DeterminerForm outcomes={outcomes} personas={personas} determiner={determiners.find((determiner) => determiner.id == id)}/>
        )} />
      </Switch>
    </ReloadParentWrapper>
  );

};

Determiners.propTypes = {
  graph_loading: bool,
  determiners: array,
  graph_data: object,
  reload_graph: func,
  personas: array,
  outcomes: array
};

Determiners.query = async () => {
  return await ReferralEngineQuery(`
    {
      determiners {
        id
        uuid
        title
        logic_string

        persona {
          id
          name
          outcomes {
            id
            name
          }
        }
      }

      personas {
        id
        name
        description
        outcomes {
          id
          name
        }
      }

      outcomes {
        id
        name
        description
      }
    }`
  );
};

export default withData(Determiners);
